import * as Yup from "yup";
import { PaymentMethods } from "../components/PaymentMethod";

export const AddFundsSchema = Yup.object().shape({
  coins: Yup.number()
    .required()
    .positive()
    .min(10),
  payment_method: Yup.string()
    .oneOf([...Object.values(PaymentMethods)])
    .required(),
  // attachments: Yup.mixed().required(),
  attachments: Yup.mixed().when("payment_method", {
    is: (val) => {
      // console.log({
      //   val,
      //   test: [
      //     PaymentMethods.bank_transfer,
      //     PaymentMethods.cash,
      //     PaymentMethods.voucher,
      //   ].includes(val),
      // });
      return [
        PaymentMethods.bank_transfer,
        PaymentMethods.cash,
        PaymentMethods.voucher,
      ].includes(val);
    },
    then: Yup.mixed().required(),
  }),
  bank: Yup.string().when("payment_method", {
    is: (val) => val === PaymentMethods.bank_transfer,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.strip(["bank"]),
  }),
});
